(function () {
    'use strict';
    /*
     * Copyright (c) 2017 In Hand Health.
     * All rights reserved.
     */
    angular
        .module('ihh-common-web')
        .controller('CampaignPrescriptionCtrl', CampaignPrescriptionCtrl);

    CampaignPrescriptionCtrl.$inject = ['$scope', '$routeParams', 'RestResources', 'CampaignPrescriptionsService', 'CampaignConstants', 'ObserverService', '_', 'FrequencyService', 'ResearchUtilities', 'RxExUtilities', 'Utilities', 'EpisodeTemplateService'];

    function CampaignPrescriptionCtrl($scope, $routeParams, RestResources, CampaignPrescriptionsService, CampaignConstants, ObserverService, _, FrequencyService, ResearchUtilities, RxExUtilities, Utilities, EpisodeTemplateService) {
        var vm = this;
        var campaignId = $routeParams.campaignId;
        var confirmAwaySetup = false;

        vm.isEdit = false;
        vm.edit = edit;
        vm.save = save;
        vm.cancel = cancel;
        vm.remove = remove;
        vm.frequencyOptions = FrequencyService.frequencyOptions;
        vm.getExerciseThumbnailUrl = getExerciseThumbnailUrl;
        vm.getExerciseLinkUrl = getExerciseLinkUrl;
        vm.displayQuantityType = ResearchUtilities.displayQuantityType;
        vm.deleteExerciseTemplate = deleteExerciseTemplate;
        vm.quantityTypes = RxExUtilities.getQuantityTypes();
        vm.getQuantityType = getQuantityType;
        vm.setQuantityType = setQuantityType;
        vm.selectQuantityType = selectQuantityType;
        vm.getResistanceItemValue = getResistanceItemValue;
        vm.setResistanceItemValue = setResistanceItemValue;
        vm.getValueString = getValueString;
        vm.disableEditButtons = disableEditButtons;
        vm.updateExpanded = updateExpanded;

        vm.isMetronome = isMetronome;
        vm.getMetronome = getMetronome;
        vm.isEmptyDropzone = isEmptyDropzone;

        vm.showExpireAfterDays = vm.hasClinicFeature && vm.clinic && vm.hasClinicFeature(vm.clinic, 'Prescription Expire After Days');
        vm.showGamifySequence = vm.hasClinicFeature && vm.clinic && vm.hasClinicFeature(vm.clinic, 'Prescription Gamification');

        vm.getFrequencyLabel = FrequencyService.getFrequencyLabel;

        activate();

        function activate() {
            processPrescription(vm.prescription);

            if (_.has(vm.prescription, '_id')) {
                edit(); // this prescription is new and there isn't a need to wait for user to click edit button
            }

            var unwatchFormInit = $scope.$watch(CampaignConstants.form.campaignPrescriptionForm, function (theForm) {
                if (theForm) {
                    unwatchFormInit();
                    ObserverService.notifyObservers(CampaignConstants.observers.form.formReady, vm.CampaignPrescriptionForm);
                }
            });

            if (vm.index === 0) {
                vm.prescription._expanded = true;
            }

            ObserverService.registerObserverCallback(CampaignConstants.observers.expanded.collapseAll, function (callback) {
                if (vm.prescription) {
                    vm.prescription._expanded = false;
                }
                callback();
            });
        }

        function remove() {
            displayBusyIndicator();

            Utilities.confirmDialog(CampaignConstants.prescription.remove.confirmDialog, function () {
                vm.prescriptionsCrud.delete(campaignId, vm.episodeModel.id, vm.prescription.id).then(function () {
                    ObserverService.notifyObservers(CampaignConstants.observers.prescription.remove, {
                        id: vm.prescription.id
                    });
                }, function (err) {
                    RestResources.reportRestError(CampaignConstants.prescription.remove.errorString, err);
                }).finally(function () {
                    hideBusyIndicator();
                });
            });
        }

        function getQuantityType(exerciseTemplate) {
            return RxExUtilities.getQuantityType(exerciseTemplate);
        }

        function setQuantityType(state, exerciseTemplate/*, form*/) { // eventually pass form through
            RxExUtilities.setQuantityType(state, exerciseTemplate, {
                '$setDirty': function () { }
            });
        }

        function selectQuantityType(quantityType, exerciseTemplate, form/*, $event*/) { // eventually pass event through
            setQuantityType(quantityType, exerciseTemplate, form);
        }

        function getResistanceItemValue(exerciseTemplate) {
            return RxExUtilities.getResistanceItemValue(exerciseTemplate);
        }

        function setResistanceItemValue(state, exerciseTemplate/*, form*/) { // eventually pass form through
            RxExUtilities.setResistanceItemValue(state, exerciseTemplate, {
                '$setDirty': function () { }
            });
        }

        function getValueString(value) {
            var returnValue = value;

            if (returnValue === 'Repetitions') {
                returnValue = 'Reps';
            }

            return returnValue;
        }

        function save() {
            displayBusyIndicator();

            FrequencyService.updateFrequency(vm.rxTemp);

            if (!_.has(vm.rxTemp, 'id')) {
                vm.prescriptionsCrud.create(campaignId, vm.episodeModel.id, vm.rxTemp).then(function (result) {
                    vm.prescription = result;
                    isEdit(false);
                    CampaignPrescriptionsService.cancel();

                    ObserverService.notifyObservers(CampaignConstants.observers.prescriptions.reset, {});
                }, function (err) {
                    RestResources.reportRestError('', err);
                }).finally(function () {
                    hideBusyIndicator();
                });
            }
            else {
                vm.prescriptionsCrud.update(campaignId, vm.episodeModel.id, vm.rxTemp.id, vm.rxTemp).then(function (result) {
                    vm.prescription = result;
                    isEdit(false);
                    CampaignPrescriptionsService.cancel();

                    ObserverService.notifyObservers(CampaignConstants.observers.prescriptions.reset, {});
                }, function (err) {
                    RestResources.reportRestError('', err);
                }).finally(function () {
                    hideBusyIndicator();
                });
            }
            deregisterObserverCallbacks();
        }

        function deleteExerciseTemplate(exerciseTemplate) {
            var exerciseTemplateIndex;

            exerciseTemplateIndex = _.findIndex(vm.rxTemp.prescriptionExercises, function (exercise) {
                return exercise._id === exerciseTemplate._id;
            });

            if (exerciseTemplateIndex !== -1) {
                vm.rxTemp.prescriptionExercises.splice(exerciseTemplateIndex, 1);
            }
        }

        function cancel() {
            deregisterObserverCallbacks();
            isEdit(false);

            vm.prescription._expanded = false;
            CampaignPrescriptionsService.cancel();

            if (_.has(vm.prescription, 'id')) {
                ObserverService.notifyObservers(CampaignConstants.observers.prescription.cancel, vm.prescription.id);
            }
            else {
                ObserverService.notifyObservers(CampaignConstants.observers.prescription.cancelPrescriptionCreation);
            }
        }

        function getEditId() {
            var prescription = getModel();
            return prescription.id || prescription._id;
        }

        function getModel() {
            if (isEdit()) {
                return vm.rxTemp;
            }

            return vm.prescription;
        }

        function disableEditButtons() {
            return CampaignPrescriptionsService.isEdit() && CampaignPrescriptionsService.getEditId() !== getEditId();
        }

        function updateExpanded() {
            vm.prescription._expanded = !vm.prescription._expanded;
        }

        function processPrescription(prescription) {
            if (!Utilities.isDefinedAndNotNull(prescription.prescriptionExercises)) {
                prescription.prescriptionExercises = [];
            }

            vm.prescription._expanded = false;
        }

        function edit() {
            registerObserverCallbacks();
            isEdit(true);

            vm.rxTemp = angular.copy(vm.prescription);
            FrequencyService.initFrequency(vm.rxTemp);

            ObserverService.notifyObservers(CampaignConstants.observers.expanded.collapseAll, function () {
                vm.prescription._expanded = true;
            });

            CampaignPrescriptionsService.edit(vm.rxTemp.id || vm.rxTemp._id);

            ObserverService.notifyObservers(CampaignConstants.observers.prescription.edit, {});

            setupConfirmAway();
        }

        // uses a promise to display the busy indicator
        function displayBusyIndicator() {
            EpisodeTemplateService.displayBusyIndicator();
        }

        // clears the promise so that the busy indicator will no longer be displayed
        function hideBusyIndicator() {
            EpisodeTemplateService.hideBusyIndicator();
        }

        function getExerciseThumbnailUrl(exerciseTemplate) {
            return RxExUtilities.getExerciseThumbnailUrl(exerciseTemplate.exercise);
        }

        function getExerciseLinkUrl(exerciseTemplate, isEdit) {
            return RxExUtilities.getExerciseLinkUrl(exerciseTemplate, isEdit);
        }

        // This function determines if there is a conflict
        function hasConflict(rxTemp, protocolData) {
            return hasStringConflict(rxTemp.name, protocolData.title) || hasStringConflict(rxTemp.instructions, protocolData.instructions) || hasFrequencyConflict(rxTemp.frequency.value, protocolData.frequencyValue);
        }

        // This function determines if there is a frequency per day conflict
        function hasFrequencyConflict(frequencyPerDay, protocolFrequencyPerDay) {
            return angular.isDefined(frequencyPerDay) && frequencyPerDay !== protocolFrequencyPerDay;
        }

        // This function determines if there is a
        function hasStringConflict(strA, strB) {
            return angular.isDefined(strA) && strA !== null && strA !== '' && strA !== strB;
        }

        function updateExerciseTemplate(exerciseTemplate, exercise) {
            var updatedExerciseTemplate = _.clone(exerciseTemplate);

            if (exercise.created) {
                updatedExerciseTemplate.sets = exercise.sets;
                updatedExerciseTemplate.repetitions = exercise.repetitions;
                updatedExerciseTemplate.secondsPerRep = exercise.secondsPerRep;
                updatedExerciseTemplate.duration = exercise.duration;
                updatedExerciseTemplate.quantityType = exercise.quantityType;
                if (!Utilities.isDefinedAndNotNull(updatedExerciseTemplate.quantityType)) {
                    if (!Utilities.isDefinedAndNotNull(updatedExerciseTemplate.repetitions) && Utilities.isDefinedAndNotNull(updatedExerciseTemplate.duration)) {
                        updatedExerciseTemplate.quantityType = vm.quantityTypes[1];
                    }
                    else {
                        updatedExerciseTemplate.quantityType = vm.quantityTypes[0];
                    }
                }
                updatedExerciseTemplate.metronome = exercise.metronome;
                updatedExerciseTemplate.resistanceItemValue = exercise.resistanceItemValue;
                updatedExerciseTemplate.resistanceItem = exercise.resistanceItem;
                updatedExerciseTemplate.instructions = exercise.instructions;
                updatedExerciseTemplate.cuesAndTips = exercise.cuesAndTips;
                updatedExerciseTemplate.ttsInstructions = exercise.ttsInstructions;
                updatedExerciseTemplate.ttsCuesAndTips = exercise.ttsCuesAndTips;
            }

            return updatedExerciseTemplate;
        }

        function processChooserExerciseTemplate(exerciseTemplate) {
            var updatedExerciseTemplate = updateExerciseTemplate(exerciseTemplate, exerciseTemplate.exercise);

            updatedExerciseTemplate._id = _.uniqueId();

            return updatedExerciseTemplate;
        }

        function deregisterObserverCallbacks() {
            ObserverService.deregisterObserverCallback(CampaignConstants.observers.prescription.quickAdd);
            ObserverService.deregisterObserverCallback(CampaignConstants.observers.prescription.quickAddWithIndex);
            ObserverService.deregisterObserverCallback(CampaignConstants.observers.prescription.updateProtocolDetails);
        }

        function registerObserverCallbacks() {
            ObserverService.registerObserverCallback(CampaignConstants.observers.prescription.quickAdd, function (selectedItems) {
                angular.forEach(selectedItems, function (item) {
                    var newItem = processChooserExerciseTemplate(item);
                    angular.extend(newItem, {
                        _id: _.uniqueId()
                    });

                    vm.rxTemp.prescriptionExercises.push(newItem);
                });
            });

            ObserverService.registerObserverCallback(CampaignConstants.observers.prescription.quickAddWithIndex, function (selectedItems) {
                var exerciseTemplates = selectedItems.exerciseTemplates;
                var index = selectedItems.index;
                for (var i = 0; i < exerciseTemplates.length; i++) {
                    var item = exerciseTemplates[i];
                    vm.rxTemp.prescriptionExercises.splice(index, 0, processChooserExerciseTemplate(item));
                    index++;
                }
            });

            ObserverService.registerObserverCallback(CampaignConstants.observers.prescription.updateProtocolDetails, function (protocol) {
                addSelectedPrescriptionProtocol(protocol);
            });
        }

        function addSelectedPrescriptionProtocol(item) {
            var rxTemplate = vm.rxTemp;
            var protocolInstructions = item.instructions;
            var protocolTitle = item.title;
            var protocolFrequencyPerDay = item.frequencyPerDay;
            var protocolData = {
                name: protocolTitle,
                instructions: protocolInstructions,
                frequencyValue: protocolFrequencyPerDay
            };

            if (hasConflict(rxTemplate, protocolData)) {
                Utilities.confirmDialog('The selected template has been added to the prescription. Name, Frequency, or Special Instructions have already been entered. Select Continue to overwrite with data from the prescription template or Cancel to keep current entries.', function () {
                    updatePrescriptionFormValues(rxTemplate, protocolInstructions, protocolTitle, protocolFrequencyPerDay);
                }, function () {
                    angular.noop();
                }, "Overwrite Data?");
            }
            else {
                updatePrescriptionFormValues(rxTemplate, protocolInstructions, protocolTitle, protocolFrequencyPerDay);
            }
        }

        // This function updates a prescription form with the supplied values
        function updatePrescriptionFormValues(rxTemplate, instructions, name, frequencyPerDay) {
            rxTemplate.instructions = instructions;
            rxTemplate.name = name;

            updatePrescriptionFrequencyValues(rxTemplate, frequencyPerDay);
        }

        function updatePrescriptionFrequencyValues(rxTemplate, frequencyPerDay) {
            rxTemplate.frequencyPerDay = frequencyPerDay;
        }

        /**
         * Updates the isEdit value with any value passed, and returns the current value.
         *
         * @param {Boolean} val - if sent, sets the isEdit value
         * @returns {Boolean} the current value of isEdit
         */
        function isEdit(val) {
            if (val === true || val === false) {
                vm.isEdit = val;
            }

            return vm.isEdit;
        }
        /**
         * Does the setup necessary to create a confirmation when the user leaves the page when the form has been dirtied.
         */
        function setupConfirmAway() {
            if (isEdit() && !confirmAwaySetup) {
                var unwatchFormInit = $scope.$watch(CampaignConstants.form.campaignPrescriptionForm, function (theForm) {
                    if (theForm) {
                        Utilities.confirmAway($scope, theForm);
                        confirmAwaySetup = true;

                        unwatchFormInit();
                    }
                });
            }
        }

        /**
         * Returns whether the metronome value is considered set, either at the template or
         * exercise.
         * @param {type} exerciseTemplate the template
         * @returns {Boolean} true if the metronome is set (even to zero)
         */
        function isMetronome(exerciseTemplate) {
            return exerciseTemplate.metronome >= 0 || exerciseTemplate.exercise.metronome >= 0;
        }

        /**
         * Returns the effective value that should be displayed for the metronome.  If a value is set
         * (including zero) at the template level then that is the value.  Otherwise, if a value is set
         * at the exercise level than that is the value.  Otherwise undefined.
         * @param {type} exerciseTemplate the template
         * @returns {Number|undefined} The effective metronome or null or undefined if it is not present
         */
        function getMetronome(exerciseTemplate) {
            return exerciseTemplate.metronome >= 0 ? exerciseTemplate.metronome : exerciseTemplate.exercise.metronome;
        }

        /**
         * Returns whether the template drop zone is empty.
         * @returns {Boolean} true if the template drop zone is empty
         */
        function isEmptyDropzone() {
            return !vm.rxTemp.prescriptionExercises || vm.rxTemp.prescriptionExercises.length === 0;
        }
    }
})();
